import { render, staticRenderFns } from "./reservationSetting.vue?vue&type=template&id=1b693b33&scoped=true"
import script from "./reservationSetting.vue?vue&type=script&lang=js"
export * from "./reservationSetting.vue?vue&type=script&lang=js"
import style0 from "./reservationSetting.vue?vue&type=style&index=0&id=1b693b33&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b693b33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b693b33')) {
      api.createRecord('1b693b33', component.options)
    } else {
      api.reload('1b693b33', component.options)
    }
    module.hot.accept("./reservationSetting.vue?vue&type=template&id=1b693b33&scoped=true", function () {
      api.rerender('1b693b33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/reservationSetting.vue"
export default component.exports